import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";
import { useState, useEffect } from "react";
import { userGetSubcriptionPricing } from "../../apiservice/userService";
import { IBookTypeData, IPricingData } from "../../apiservice/userService.type";
import {
  getCacheSubscriptionPlan,
  Cache_Subscription_Plan_Key,
} from "../../utils/apiSample/recommendation";
import { useNavigate } from "react-router-dom";
import { formatCurrency } from "../../utils/basic.utils";

interface PaymentOnboardingBookProps {
  bookData?: IBookTypeData;
}

const PaymentOnboardingBook = ({ bookData }: PaymentOnboardingBookProps) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [plan, setPlan] = useState<IPricingData[]>([]);

  const navigate = useNavigate();

  const fetchSubscriptionPlan = async () => {
    try {
      const cacheData = await getCacheSubscriptionPlan();
      if (cacheData?.length > 0) {
        setPlan(cacheData);
        setLoading(false);
      }

      const subPlanData = await userGetSubcriptionPricing();
      if (subPlanData) {
        setPlan(subPlanData?.data);

        localStorage.setItem(
          Cache_Subscription_Plan_Key,
          JSON.stringify(subPlanData?.data)
        );
      } else {
        setError("Category not found");
      }
    } catch (err) {
      setError("Failed to load book data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSubscriptionPlan();
  }, []);

  const proceed = async (e) => {
    e.preventDefault();
    navigate(
      "/users/subscription-payment?type=2&id=" +
      (bookData?.id || 0) +
      "&price=" +
      (bookData?.price || 0) +
      "&title=" +
      bookData?.title || "" + ""
    );
  };

  if (loading) {
    return (
      <div className="p-4 text-center">Loading Subscription details...</div>
    );
  }

  if (error || !plan) {
    return (
      <div className="p-4 text-center text-red-500">
        {error || "Subscription  not found"}
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center p-4 bg-white dark:bg-stone-900 relative">
      {/* <button className="absolute top-4 left-4 text-xl text-black dark:text-white">
        <CloseOutlined />
      </button> */}
      <Swiper
        pagination={{ clickable: true }}
        modules={[Pagination]}
        className="w-full max-w-sm"
      >
        <SwiperSlide>
          <div className="flex flex-col items-center text-center mb-12">
            <img
              src={bookData?.coverImageUrl || "/images/PaymentPage/image1.svg"}
              alt="Onboarding"
              className="w-60 h-60 object-contain mb-4"
            />
            <h2 className="text-xl font-semibold text-gray-900 dark:text-stone-100">
              {bookData?.title}
            </h2>
            <p className="text-gray-500 dark:text-stone-400 text-sm mt-2 px-6">
              You are about to make a lifetime payment for the audio summary of
              this book.
            </p>
          </div>
        </SwiperSlide>
      </Swiper>

      <div className="flex flex-col items-center text-center">
        <p className="text-gray-500 dark:text-stone-400 text-sm mt-2">
          Only {formatCurrency(bookData?.price)} for this book Audio summary.
        </p>
      </div>
      <button
        onClick={proceed}
        className="w-full bg-blue-800 hover:bg-blue-700 dark:hover:bg-blue-600 text-white max-w-sm mt-6 p-4 rounded-md"
      >
        Life Time Purchase {formatCurrency(bookData?.price)}
      </button>
      {/* <button className="text-sm text-gray-500 dark:text-stone-400 mt-2">View other plans</button> */}
      {/* <div className="flex justify-between text-sm text-gray-400 dark:text-stone-500 w-full max-w-sm mt-6">
        <button className="hover:text-gray-600 dark:hover:text-stone-300">Terms & Conditions</button>
        <button className="hover:text-gray-600 dark:hover:text-stone-300">Privacy Policy</button>
      </div> */}
    </div>
  );
};

export default PaymentOnboardingBook;
